module.exports = __webpack_public_path__ + "static/img/12.9cda93f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/12.png
// module id = jHDp
// module chunks = 0